import map from 'lodash/map';
import TableColumnsSwitcherStorage from '@Services/AppDBStorage/Storages/TableColumnsSwitcherStorage';

// States
const DYNAMIC = 'dynamic'; // List of DEFAULTS columns will be calculated on the available space
const NONEMPTY = 'nonempty'; // All non empty columns
const CUSTOM = 'custom'; // Selected in combo
const SAVED = 'saved'; // Stored in the storage

function getCSSId({ id }) {
  return (id || '').replace(/\./g, '-');
}

function generateCssRules(tableId, headers) {
  return map(
    headers,
    ({ cssid }) => `
        .${tableId}.show-${cssid}       .column-${cssid} {display: table-cell;}
        .${tableId}.show-more-${cssid}  .column-${cssid} {position:relative;padding-left: 2.5rem;overflow: hidden;}
        .${tableId}.show-more-${cssid}  .column-${cssid} .show-more {display: block}
        .${tableId}.show-more-${cssid}  .column-${cssid}:before,
        .${tableId}.show-more-${cssid}  .column-${cssid}:after {display: block!important;}
        `
  ).join('');
}

function getTableColumns(columns, filter) {
  if (!columns) {
    return [];
  }
  return filter ? columns.filter(filter) : columns;
}

function getSelectedColumns(headers) {
  return getTableColumns(headers, ({ _isChecked }) => _isChecked);
}

function getVisibleColumns(columns) {
  return getTableColumns(columns, ({ isVisible }) => isVisible);
}

function getVisibleColumnsClass(headers) {
  return getVisibleColumns(headers)
    .map(({ cssid }) => `show-${cssid}`)
    .join(' ');
}

function getHiddenColumnsAmount(headers) {
  return getTableColumns(headers, (header) => header.hasContent && header.isVisible === false).length;
}

function getLastVisibleColumnClass(headers) {
  const list = getTableColumns(headers);
  let i = list.length;
  if (getHiddenColumnsAmount(headers)) {
    // eslint-disable-next-line no-plusplus
    while (i--) {
      if (list[i].isVisible && list[i].hasContent) {
        return getCSSId(list[i]);
      }
    }
  }
  return '';
}

function getTableClass(tableId, headers) {
  return [
    'integrated-with-columns-switcher',
    tableId,
    getVisibleColumnsClass(headers),
    `show-more-${getLastVisibleColumnClass(headers)}`,
  ].join(' ');
}

function saveColumns(tableId, headers) {
  if (this.currentSwitcherState === this.DYNAMIC) {
    TableColumnsSwitcherStorage.remove(tableId);
  } else {
    TableColumnsSwitcherStorage.set(tableId, getSelectedColumns(headers));
  }
}

const ReactTableColumnSwitcherHelper = {
  DYNAMIC,
  NONEMPTY,
  CUSTOM,
  SAVED,
  getCSSId,
  generateCssRules,
  getTableClass,
  getSelectedColumns,
  getTableColumns,
  getLastVisibleColumnClass,
  saveColumns,
  getHiddenColumnsAmount,
};

export default ReactTableColumnSwitcherHelper;
